import { useState, useEffect, useRef } from "react";
import {
  Page,
  Navbar,
  BtnSmallDisabled,
  DialogBox,
  BtnSmall,
  PopUp,
  Loader,
} from "../components";
import {
  Link as RouterLink,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import * as ROUTES from "../constant/routes";
import {
  deleteAllBooksInCart,
  // getAllBooksInCart,
  // removeABookInCart,
  updateQuantity,
  payForAccessIds,
  verifyOtp,
  wallet,
} from "../assets/Js/script";
import Timeout from "../helpers/Timeout";

export default function BookRenew() {
  const [modals, setModals] = useState({
    payment: false,
    commissionCost: false,
    hamburger: false,
    validity: false,
    loader: false,
    confirmCartEmpty: false,
  });
  const { selectedBooks: books } = useLocation();
  const [inSufficientBalance, setInSufficientBalance] = useState(false);
  const [paid, setPaid] = useState(false);
  const [confirmOTP, setConfirmOTP] = useState(false);
  const [accessIdCreated, setAccessIdCreated] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [check, setCheck] = useState(null);
  const [payment, setPayment] = useState({
    book: 0,
    commission: 0,
    final: 0,
  });
  const [walletDetails, setWalletDetails] = useState(null);
  const [booksData, setBooksData] = useState([]);

  // async function handleRemoveBook(id, i) {
  //   setSelectedMenu(null);
  //   setSelectedBooks((prevState) => [
  //     ...prevState.filter((book, index) => i !== index),
  //   ]);
  //   const { response, error } = await removeABookInCart(id, true);
  // }

  function handleCalculateCost() {
    setPayment((prevState) => {
      let total = 0;
      selectedBooks.forEach((item) => {
        total += item.numberOfCopies * parseInt(item.unitPriceCredits);
      });
      let commission = total / 10;
      return {
        ...prevState,
        book: total,
        commission,
        final: total + commission,
      };
    });
  }

  async function handleQuantity(increase, index, quantity) {
    if (quantity > 1 || increase) {
      const { response, error } = await updateQuantity(
        selectedBooks[index].id,
        increase ? quantity + 1 : quantity - 1,
        true
      );
      if (response.status === "success") {
        setSelectedBooks((prevState) => {
          prevState[index].numberOfCopies = increase
            ? quantity + 1
            : quantity - 1;
          return [...prevState];
        });
      }
    }
  }

  function handleRepeat(index) {
    setSelectedMenu(null);
    setSelectedBooks((prevState) => {
      return [
        ...prevState.slice(0, index + 1),
        prevState[index],
        ...prevState.slice(index + 1),
      ];
    });
  }

  function handleValidity(validity, index) {
    setSelectedBooks((prevState) => {
      prevState[index].validity = validity;
      return [...prevState];
    });
  }

  function renderValidity(validity, index) {
    let valArr = [];
    for (let i = 1; i <= validity; i++) {
      valArr.push(
        <button
          onClick={() => {
            setModals((prevState) => ({ ...prevState, validity: false }));
            handleValidity(i, index);
          }}
          className="hover:bg-[#f3ebf2] w-full text-heading-false h-8 text-[19px] font-semibold leading-[23px]"
        >
          {i}
        </button>
      );
    }
    return valArr;
  }

  async function handleClearCart() {
    setModals((prevState) => ({
      ...prevState,
      loader: true,
      confirmCartEmpty: false,
    }));
    const { response, error } = await deleteAllBooksInCart(selectedBooks, true);
    setSelectedBooks([]);
    setModals((prevState) => ({ ...prevState, loader: false }));
  }

  async function handlePayment() {
    const { response, error } = await payForAccessIds(
      Math.floor(payment?.final)
    );
    if (response.status === "success") {
      setPaid(true);
    }
  }

  // OTP
  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
    fifth: "",
    sixth: "",
  });

  function handleOtp(e) {
    const { name, value } = e.target;
    setOtp((prevState) => ({
      ...prevState,
      [name]: value.length > 1 ? prevState[name] : value,
    }));
  }

  useEffect(() => {
    handleCalculateCost();
  }, [selectedBooks]);

  async function getWallet() {
    const { response, error } = await wallet();
    if (response.status === "success") {
      setWalletDetails({ ...response.data });
    }
  }

  // useEffect(() => {
  //   getWallet();
  //   (async () => {
  //     const { response, error } = await getAllBooksInCart("accessId");
  //     if (response.status === "success") {
  //       setBooksData([...response.data.bookData]);

  //       setSelectedBooks([...response.data.allBooks]);

  //       setInSufficientBalance(
  //         parseFloat(payment?.final) >
  //           parseFloat(walletDetails?.myCredits?.credits)
  //       );
  //     }
  //   })();
  // }, []);

  const firstInputRef = useRef(null);
  const secondInputRef = useRef(null);
  const thirdInputRef = useRef(null);
  const fourthInputRef = useRef(null);
  const fifthInputRef = useRef(null);
  const sixthInputRef = useRef(null);

  useEffect(() => {
    for (const key in otp) {
      if (otp[key] === "") {
        if (key === "first") {
          firstInputRef.current && firstInputRef.current.focus();
        } else if (key === "second") {
          secondInputRef.current && secondInputRef.current.focus();
        } else if (key === "third") {
          thirdInputRef.current && thirdInputRef.current.focus();
        } else if (key === "fourth") {
          fourthInputRef.current && fourthInputRef.current.focus();
        } else if (key === "fifth") {
          fifthInputRef.current && fifthInputRef.current.focus();
        } else if (key === "sixth") {
          sixthInputRef.current && sixthInputRef.current.focus();
        }
        setConfirmOTP(false);

        break;
      } else {
        setConfirmOTP(true);
      }
    }
  }, [otp]);

  async function otpVerification() {
    const { response, error } = await verifyOtp(
      `${otp.first}${otp.second}${otp.third}${otp.fourth}${otp.fifth}${otp.sixth}`,
      true
    );
  }

  useEffect(() => {
    function handleCloseMenu() {
      setSelectedMenu(null);
      setModals((prevState) => ({ ...prevState, validity: false }));
    }
    window.addEventListener("click", handleCloseMenu);

    return () => {
      window.removeEventListener("click", handleCloseMenu);
    };
  }, []);

  return (
    <Page active="wallet">
      <Navbar />
      {modals.loader ? (
        <Loader show={modals.loader} />
      ) : (
        <>
          <div className="flex items-center justify-between">
            <div className=" flex items-center">
              <button onClick={() => navigate(-1)} className="-ml-6 mr-2">
                <svg
                  width="29"
                  height="27"
                  viewBox="0 0 29 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7109 21.3749C16.5303 21.3755 16.352 21.3384 16.1889 21.2664C16.0258 21.1944 15.8821 21.0892 15.7684 20.9587L9.93211 14.2087C9.75438 14.0074 9.65723 13.7549 9.65723 13.4943C9.65723 13.2337 9.75438 12.9812 9.93211 12.7799L15.9738 6.02994C16.1789 5.8002 16.4736 5.65572 16.7931 5.6283C17.1126 5.60087 17.4308 5.69274 17.6775 5.88369C17.9243 6.07465 18.0795 6.34905 18.1089 6.64653C18.1384 6.94401 18.0397 7.2402 17.8346 7.46994L12.4334 13.4999L17.6534 19.5299C17.8011 19.6951 17.895 19.8962 17.9238 20.1094C17.9527 20.3226 17.9153 20.5391 17.8162 20.7332C17.717 20.9273 17.5602 21.0909 17.3643 21.2046C17.1685 21.3183 16.9417 21.3775 16.7109 21.3749Z"
                    fill="#494949"
                  />
                </svg>
              </button>
              <h2 className="text-heading text-h4 font-semibold text-left ">
                Book Renew
              </h2>
            </div>
            <button
              onClick={() =>
                setModals((prevState) => ({
                  ...prevState,
                  confirmCartEmpty: true,
                }))
              }
              className="underline text-secondary-dark font-semibold text-[18px] leading-[22px]"
            >
              Remove all the items
            </button>
          </div>
          {/* {selectedBooks.length > 0 ? ( */}
            <div className="my-8 flex justify-between">
              <div className="w-2/3 max-w-[757px]  mr-8">
                {/* {selectedBooks.map((book, i) => ( */}
                  <div
                    // key={i + book.id}
                    className="flex bg-neutral-0 mb-4 h-[226px] border-1 border-solid border-primary-gray"
                  >
                    <div className="w-40 bg-neutral-10">
                      {/* <img
                        src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${booksData[i]["Books"][0]?.imageCoverFront}`}
                        alt="front cover"
                        className="h-full object-cover"
                      /> */}
                    </div>
                    <div className="p-4 w-id-card">
                      <div className="flex justify-between items-center mb-6 ">
                        <h3 className="text-heading font-semibold text-p1 text-left">
                         THYEX-HHJFXC-KJK {/* {booksData[i]["Books"][0]?.title} */}
                        </h3>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            // setSelectedMenu(i);
                          }}
                          className="relative outline-0 border-0"
                        >
                          <svg
                            width="4"
                            height="18"
                            viewBox="0 0 4 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.875 15.25C3.875 15.7473 3.67746 16.2242 3.32583 16.5758C2.97419 16.9275 2.49728 17.125 2 17.125C1.50272 17.125 1.02581 16.9275 0.674175 16.5758C0.322544 16.2242 0.125 15.7473 0.125 15.25C0.125 14.7527 0.322544 14.2758 0.674175 13.9242C1.02581 13.5725 1.50272 13.375 2 13.375C2.49728 13.375 2.97419 13.5725 3.32583 13.9242C3.67746 14.2758 3.875 14.7527 3.875 15.25ZM3.875 9C3.875 9.49728 3.67746 9.97419 3.32583 10.3258C2.97419 10.6775 2.49728 10.875 2 10.875C1.50272 10.875 1.02581 10.6775 0.674175 10.3258C0.322544 9.97419 0.125 9.49728 0.125 9C0.125 8.50272 0.322544 8.02581 0.674175 7.67417C1.02581 7.32254 1.50272 7.125 2 7.125C2.49728 7.125 2.97419 7.32254 3.32583 7.67417C3.67746 8.02581 3.875 8.50272 3.875 9ZM3.875 2.75C3.875 3.24728 3.67746 3.72419 3.32583 4.07583C2.97419 4.42746 2.49728 4.625 2 4.625C1.50272 4.625 1.02581 4.42746 0.674175 4.07583C0.322544 3.72419 0.125 3.24728 0.125 2.75C0.125 2.25272 0.322544 1.77581 0.674175 1.42417C1.02581 1.07254 1.50272 0.875 2 0.875C2.49728 0.875 2.97419 1.07254 3.32583 1.42417C3.67746 1.77581 3.875 2.25272 3.875 2.75Z"
                              fill="#9C9C9C"
                            />
                          </svg>
                          {selectedMenu  && (
                            <div
                              onClick={(e) => e.stopPropagation()}
                              className="flex flex-col justify-between box-border p-4 shadow-[3px_3px_2px_rgba(135,133,133,0.13)] border-solid border-[#AEAEAE] border-1 z-[99] absolute top-0 right-3 h-[84px] w-[149px] bg-primary-white"
                            >
                              <button
                                // onClick={() => handleRepeat(i)}
                                className="w-full box-border flex items-center justify-between text-secondary-dark font-semibold text-montserrat text-p1"
                              >
                                <span>
                                  <svg
                                    width="15"
                                    height="14"
                                    viewBox="0 0 15 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.472 2.35949C9.72627 -0.203164 5.27408 -0.203164 2.52838 2.35949C-0.217793 4.92259 -0.217793 9.07752 2.52838 11.6402C5.27408 14.2033 9.72627 14.2033 12.472 11.6402C15.2177 9.07752 15.2177 4.92259 12.472 2.35949ZM3.28143 6.90118C3.28143 6.27446 3.54041 5.68602 4.01127 5.24305C4.24123 5.02488 4.51552 4.85173 4.81808 4.73374C5.12065 4.61576 5.44539 4.55532 5.7733 4.55596H8.53213V3.71859L11.2504 5.19559L8.53213 6.67259V5.83521H5.7733C5.14869 5.83521 4.64104 6.3134 4.64104 6.90118C4.64104 6.92984 4.64197 6.95849 4.64432 6.98715L3.41338 7.65631C3.32551 7.41301 3.28094 7.15792 3.28143 6.90118ZM10.9886 8.7553C10.7583 8.9735 10.4836 9.14668 10.1808 9.26473C9.87793 9.38278 9.55291 9.44332 9.22471 9.44284H6.47104V10.2811L3.75018 8.80277L6.47104 7.32446V8.16271H9.22447C9.84978 8.16271 10.3584 7.68343 10.3584 7.09543C10.3584 7.06809 10.357 7.04074 10.3549 7.01427L11.5888 6.34359C11.6744 6.5829 11.7189 6.83577 11.7189 7.09565C11.7189 7.72281 11.4595 8.3119 10.9886 8.7553Z"
                                      fill="#ACACAC"
                                    />
                                  </svg>
                                </span>
                                Repeat again
                              </button>
                              <button
                                // onClick={() => handleRemoveBook(book.id, i)}
                                className="w-full box-border flex items-center text-secondary-dark font-semibold text-montserrat text-p1"
                              >
                                <span className="ml-[2px] mr-[15px]">
                                  <svg
                                    width="10"
                                    height="12"
                                    viewBox="0 0 10 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0.999674 10.0833C0.999674 10.725 1.59967 11.25 2.33301 11.25H7.66634C8.39967 11.25 8.99967 10.725 8.99967 10.0833V3.08333H0.999674V10.0833ZM9.66634 1.33333H7.33301L6.66634 0.75H3.33301L2.66634 1.33333H0.333008V2.5H9.66634V1.33333Z"
                                      fill="#585858"
                                    />
                                  </svg>
                                </span>
                                Delete
                              </button>
                            </div>
                          )}
                        </button>
                      </div>
                      <div className="flex items-center">
                        <div className="flex items-center">
                          <label className="text-secondary-light font-[500] text-h5 mr-3">
                            Quantity
                          </label>
                          <div className="flex items-center justify-evenly bg-neutral-10 w-20 h-[38px]">
                            <button
                              // onClick={() =>
                                // handleQuantity(false, i, book.numberOfCopies)
                              // }
                            >
                              <svg
                                width="8"
                                height="3"
                                viewBox="0 0 8 3"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.21 0.145999H7.03V2.17H0.21V0.145999Z"
                                  fill="#5F5D5D"
                                  fillOpacity="0.79"
                                />
                              </svg>
                            </button>
                            <p className="text-heading text-h5">
                              {/* {book.numberOfCopies} */}
                            </p>
                            <button
                              // onClick={() =>
                                // handleQuantity(true, i, book.numberOfCopies)
                              // }
                            >
                              <svg
                                width="9"
                                height="9"
                                viewBox="0 0 9 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.894 5.83H0.924V3.916H3.894V0.967999H5.962V3.916H8.91V5.83H5.962V8.778H3.894V5.83Z"
                                  fill="#5F5D5D"
                                  fill-opacity="0.79"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="ml-8 flex items-center">
                          <label className="text-secondary-light text-h5 mr-3 font-[500]">
                            Validity
                          </label>
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              // setCheck(i);
                              setModals((prevState) => ({
                                ...prevState,
                                validity: true,
                              }));
                            }}
                            className="relative flex justify-evenly items-center bg-neutral-10 w-16 h-[38px]"
                          >
                            <p className="text-heading text-h5">
                              {/* {book.validity} */}
                            </p>
                            <button className="relative outline-0 border-0">
                              <svg
                                width="14"
                                height="10"
                                viewBox="0 0 14 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.33301 3.75L6.29967 7.69231L10.2663 3.75"
                                  stroke="#5F5D5D"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            {/* {modals.validity && check === i && (
                              <div className="w-full absolute top-[38px] bg-neutral-10 flex flex-col justify-between">
                                {renderValidity(book.validity, i)}
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                      <p className="mt-6 text-left text-p1 text-secondary-light flex items-center">
                        <span className="text-tertiary-dark text-h4 mr-1 font-semibold">
                          {/* {book.unitPrice} */}
                        </span>{" "}
                        Tokens
                        <span className="ml-4">x 
                        {/* {book.numberOfCopies} */}
                        </span>
                      </p>
                    </div>
                  </div>
                {/* ))} */}
              </div>
              <div className="w-[397px]">
                <div className="flex flex-col  h-[226px] bg-neutral-0 border-1 py-4 px-6 border-solid border-primary-gray mb-4">
                  <h3 className="text-heading font-semibold h-4 mb-8">
                    Payment Details
                  </h3>
                  <div className="flex w-full justify-between items-center mb-4">
                    <p className="text-secondary-dark font-[500] text-h5">
                      Total cost
                    </p>
                    <p className="text-heading font-[500] text-h5">
                      {payment.book}
                    </p>
                  </div>
                  <div className="flex w-full justify-between items-center mb-6">
                    <p className="flex items-center text-secondary-dark font-[500] text-h5">
                      Commission cost
                      <button
                        onClick={() =>
                          setModals((prevState) => ({
                            ...prevState,
                            commissionCost: true,
                          }))
                        }
                        className="ml-2"
                      >
                        <svg
                          width="20"
                          height="18"
                          viewBox="0 0 20 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 18C12.6522 18 15.1957 17.0518 17.0711 15.364C18.9464 13.6761 20 11.3869 20 9C20 6.61305 18.9464 4.32387 17.0711 2.63604C15.1957 0.948212 12.6522 0 10 0C7.34784 0 4.8043 0.948212 2.92893 2.63604C1.05357 4.32387 0 6.61305 0 9C0 11.3869 1.05357 13.6761 2.92893 15.364C4.8043 17.0518 7.34784 18 10 18ZM11.1625 7.4115L9.9125 12.7046C9.825 13.0871 9.94875 13.3043 10.2925 13.3043C10.535 13.3043 10.9012 13.2255 11.15 13.0275L11.04 13.4955C10.6812 13.8848 9.89 14.1683 9.20875 14.1683C8.33 14.1683 7.95625 13.6935 8.19875 12.6844L9.12125 8.78288C9.20125 8.45325 9.12875 8.334 8.7625 8.25412L8.19875 8.163L8.30125 7.73438L11.1637 7.4115H11.1625ZM10 6.1875C9.66848 6.1875 9.35054 6.06897 9.11612 5.858C8.8817 5.64702 8.75 5.36087 8.75 5.0625C8.75 4.76413 8.8817 4.47798 9.11612 4.267C9.35054 4.05603 9.66848 3.9375 10 3.9375C10.3315 3.9375 10.6495 4.05603 10.8839 4.267C11.1183 4.47798 11.25 4.76413 11.25 5.0625C11.25 5.36087 11.1183 5.64702 10.8839 5.858C10.6495 6.06897 10.3315 6.1875 10 6.1875Z"
                            fill="#C5C5C5"
                          />
                        </svg>
                      </button>
                    </p>
                    <p className="text-heading font-[500] text-h5">
                      {payment.commission}
                    </p>
                  </div>
                  <div className="flex w-full justify-between items-center">
                    <p className="font-semibold text-tertiary-dark text-h4">
                      Final Tokens
                    </p>
                    <p className="font-semibold text-heading text-h4">
                      {payment.final}
                    </p>
                  </div>
                </div>
                <button
                  // onClick={() =>
                    // setModals((prevState) => ({ ...prevState, payment: true }))
                  // }
                  className="w-full h-[56px] bg-primary-dark text-primary-white text-h5"
                >
                  Confirm
                </button>
              </div>
            </div>
          {/* ) : (
            <div className="flex flex-col items-center justify-center w-full h-[70%]">
              <svg
                width="101"
                height="92"
                viewBox="0 0 101 92"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M96.1892 39.4297H96.2902C98.0297 39.4297 99.6008 40.1657 100.723 41.3541C101.883 42.5079 102.601 44.1179 102.601 45.9004V46.0077V46.1074C102.601 47.8899 101.883 49.4999 100.723 50.6499C99.5971 51.8382 98.0259 52.5742 96.2865 52.5742H96.1818H95.4336L89.6691 86.5721C89.4251 88.1002 88.6441 89.484 87.4733 90.4629L87.4621 90.4706C86.3773 91.4251 84.9558 92.0077 83.4034 92.0077H19.1861C17.6337 92.0077 16.2122 91.4251 15.1199 90.4629L15.1274 90.4706C13.9604 89.4992 13.1786 88.1256 12.9278 86.6066L12.9241 86.5682L7.15962 52.5704H6.30673C4.56728 52.5704 2.99617 51.8344 1.87395 50.6461C1.27897 50.0564 0.806049 49.3499 0.483411 48.5688C0.160772 47.7877 -0.00496337 46.9479 -0.00390118 46.0997V45.9924V45.8927C-0.00390118 44.1102 0.714321 42.5002 1.87395 41.3502C2.99991 40.1619 4.57102 39.4259 6.31047 39.4259H6.41521H6.41147L96.1892 39.4297ZM24.281 80.5001C24.7007 80.4707 25.1101 80.3535 25.4839 80.1558C25.8577 79.958 26.188 79.6838 26.4544 79.3501L26.4581 79.3462C26.7423 79.0229 26.9581 78.6428 27.092 78.2298C27.2259 77.8168 27.275 77.3799 27.2362 76.9466V76.9581L25.6314 55.5987C25.6028 55.1686 25.4884 54.7491 25.2954 54.366C25.1024 53.983 24.8348 53.6445 24.5092 53.3716L24.5054 53.3677C24.1899 53.0765 23.8189 52.8554 23.4159 52.7181C23.0129 52.5809 22.5866 52.5306 22.1637 52.5704H22.1749C21.7552 52.5998 21.3458 52.7169 20.972 52.9147C20.5982 53.1125 20.2679 53.3867 20.0016 53.7204L19.9978 53.7242C19.7137 54.0476 19.4978 54.4277 19.3639 54.8407C19.23 55.2537 19.1809 55.6906 19.2198 56.1239V56.1124L20.8245 77.4717C20.8779 78.2996 21.2459 79.0731 21.8495 79.6261L21.8532 79.6299C22.4307 80.1916 23.1967 80.5045 23.9929 80.5039H24.0341H24.0304L24.281 80.5001ZM44.8738 77.2187V55.8594V55.8287C44.875 55.4029 44.7913 54.9813 44.6279 54.5898C44.4646 54.1982 44.2249 53.845 43.9236 53.5517C43.6364 53.2433 43.291 52.9979 42.9084 52.8305C42.5258 52.6631 42.1139 52.5772 41.6979 52.5781H41.638C41.2225 52.5768 40.8111 52.6626 40.429 52.83C40.0469 52.9974 39.7022 53.243 39.416 53.5517C39.115 53.846 38.8755 54.2 38.7122 54.5921C38.5488 54.9842 38.465 55.4062 38.4659 55.8326V77.2532C38.4659 78.1502 38.8287 78.9591 39.416 79.5302C39.7032 79.8387 40.0486 80.0841 40.4312 80.2515C40.8139 80.4189 41.2257 80.5048 41.6418 80.5039H41.7016C42.1172 80.5051 42.5286 80.4194 42.9106 80.252C43.2927 80.0846 43.6374 79.839 43.9236 79.5302C44.2287 79.236 44.4718 78.8807 44.6378 78.4865C44.8038 78.0922 44.8892 77.6673 44.8887 77.2379V77.2149L44.8738 77.2187ZM64.1124 77.2187V55.8594V55.8287C64.1136 55.4029 64.0299 54.9813 63.8666 54.5898C63.7032 54.1982 63.4635 53.845 63.1622 53.5517C62.8751 53.2433 62.5297 52.9979 62.147 52.8305C61.7644 52.6631 61.3525 52.5772 60.9365 52.5781H60.8766C60.4611 52.5768 60.0497 52.6626 59.6676 52.83C59.2855 52.9974 58.9408 53.243 58.6546 53.5517C58.3536 53.846 58.1141 54.2 57.9508 54.5921C57.7875 54.9842 57.7037 55.4062 57.7045 55.8326V77.2532C57.7045 78.1502 58.0674 78.9591 58.6546 79.5302C58.9418 79.8387 59.2872 80.0841 59.6699 80.2515C60.0525 80.4189 60.4643 80.5048 60.8804 80.5039H60.9402C61.3558 80.5051 61.7672 80.4194 62.1493 80.252C62.5313 80.0846 62.876 79.839 63.1622 79.5302C63.4674 79.236 63.7104 78.8807 63.8764 78.4865C64.0424 78.0922 64.1278 77.6673 64.1273 77.2379V77.2149L64.1124 77.2187ZM81.7462 77.4717L83.351 56.1124C83.3872 55.6804 83.3369 55.2454 83.2031 54.8341C83.0693 54.4227 82.8548 54.0437 82.5729 53.7204L82.5767 53.7242C82.311 53.3901 81.9815 53.1151 81.6084 52.916C81.2354 52.717 80.8265 52.598 80.4071 52.5666H80.3958C79.9743 52.5295 79.5498 52.5811 79.1484 52.7182C78.747 52.8553 78.3771 53.075 78.0616 53.3639L78.0653 53.3601C77.7393 53.6324 77.4709 53.97 77.2767 54.3523C77.0824 54.7346 76.9664 55.1535 76.9356 55.5834V55.5949L75.3309 76.9542C75.2947 77.3862 75.345 77.8213 75.4788 78.2326C75.6126 78.6439 75.827 79.0229 76.1089 79.3462L76.1052 79.3424C76.3709 79.6765 76.7004 79.9516 77.0735 80.1506C77.4465 80.3497 77.8553 80.4686 78.2748 80.5001H78.5741C79.3713 80.5001 80.1383 80.1873 80.7175 79.6261C81.3288 79.0737 81.7037 78.2972 81.7612 77.4641V77.4526L81.7462 77.4717ZM23.8471 14.9884L19.1898 36.1407H12.5762L17.6337 13.5011C18.2434 10.4919 19.8407 7.94274 22.0552 6.16024L22.0814 6.14108C24.31 4.28909 27.0939 3.28175 29.9632 3.28908H30.1053H30.0978H38.4621V3.25841C38.4621 2.36141 38.825 1.55258 39.4123 0.98141C39.6997 0.671937 40.0456 0.425671 40.4289 0.257618C40.8122 0.0895639 41.2249 0.00324152 41.6418 0.0039101H60.9515C61.8268 0.0039101 62.6161 0.375743 63.1735 0.977577C63.4745 1.27185 63.714 1.62581 63.8773 2.01791C64.0407 2.41002 64.1245 2.83207 64.1236 3.25841V3.28908H72.6263C75.6227 3.28908 78.3721 4.36241 80.5268 6.15641L80.5043 6.13724C82.7735 7.95202 84.3436 10.5304 84.9371 13.4167L84.952 13.4972L90.0095 36.1369H83.3959L78.7387 14.9846C78.4001 13.533 77.6032 12.2366 76.4718 11.2969L76.4606 11.2854C75.3596 10.3537 73.9756 9.84524 72.5478 9.84791H64.1124V9.87858C64.1136 10.3044 64.0299 10.726 63.8666 11.1175C63.7032 11.5091 63.4635 11.8623 63.1622 12.1556C62.8751 12.4641 62.5297 12.7095 62.147 12.8769C61.7644 13.0442 61.3525 13.1301 60.9365 13.1292H41.6418C41.2262 13.1305 40.8148 13.0448 40.4327 12.8773C40.0507 12.7099 39.706 12.4643 39.4198 12.1556C39.1187 11.8613 38.8792 11.5073 38.7159 11.1152C38.5526 10.7231 38.4688 10.3011 38.4696 9.87474V9.84408H30.0342C28.603 9.84242 27.2162 10.3536 26.1139 11.2892L26.1252 11.2816C25.0019 12.2138 24.2093 13.4989 23.8695 14.9386L23.862 14.9846L23.8471 14.9884Z"
                  fill="#726D6D"
                  fill-opacity="0.33"
                />
              </svg>
              <p className="text-secondary-light text-montserrat font-semibold leading-[29px] text-h1">
                Your cart is empty.
              </p>
            </div> */}
          {/* ) */}
          {/* } */}
          <DialogBox show={modals.confirmCartEmpty}>
            <PopUp
              onClick={handleClearCart}
              onClose={() =>
                setModals((prevState) => ({
                  ...prevState,
                  confirmCartEmpty: false,
                }))
              }
              button="Confirm"
              title="Remove all the items"
              main="Would you like to reset your cart?"
              body="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utvest-ibulum bibendum egestas. Enim mi arcu convallis enim purus interdum. Ut neque at adipiscing tortor facilisis sagittis libero. Ac bibendum vel blandit."
            />
          </DialogBox>

          <DialogBox show={modals.commissionCost}>
            <div className="w-[475px] p-8 bg-primary-white flex flex-col justify-between absolute">
              <h2 className="text-heading-false font-semibold text-left mb-4">
                What is the commission charge?
              </h2>
              <p className="w-[99%] text-[rgba(0,0,0,0.5)] text-[17px] text-justify mb-6">
                "Commission charge" sit amet, consectetur adipiscing elit. At
                aliquet ut facilisi nulla mauris iopsum. Pipsum dolor sit
                ametre, consectetur.
              </p>

              <div className="bg-[rgba(196,196,196,0.13)] py-[14px] px-[18px]">
                <p className="text-[15px] text-secondary-dark leading-6 mb-2">
                  For every 1000 pages commission charge is{" "}
                  <span className="text-tertiary-dark">100 Tokens</span>
                </p>
                <p className="text-[15px] text-secondary-dark leading-6">
                  For above 1000 pages commission charge is{" "}
                  <span className="text-tertiary-dark">
                    10% of
                    <br /> the number of pages
                  </span>
                </p>
              </div>

              <button
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    commissionCost: false,
                  }))
                }
                className="absolute top-8 right-8"
              >
                <svg
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                    fill="black"
                    fillOpacity="0.53"
                  />
                </svg>
              </button>
            </div>
          </DialogBox>

          {modals.payment && (
            <DialogBox show={modals.payment}>
              <div className="bg-primary-white flex flex-col justify-between relative">
                <div className=" border-[1.5px] border-solid border-primary-dark-10 p-6  w-[902px] h-[370px]">
                  {!paid ? (
                    <>
                      <h2 className="text-heading font-semibold text-left mb-3">
                        Payment
                      </h2>
                      <p className="text-secondary-light text-h5 text-justify mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        At aliquet ut facilisi nulla mauris iopsum. Pipsum dolor
                        sit ametre, consectetur adipiscing elit. At aliquet ut
                        facilisi nulla mauris.
                      </p>
                      <div className="flex items-center pl-4 mb-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                        <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                          &#8377;
                        </div>
                        <p className="text-h5 text-secondary-dark font-semibold">
                          Total Tokens Available:{" "}
                          <span className="text-heading  ml-6">
                            {Math.floor(walletDetails.myCredits.credits)}
                          </span>
                        </p>
                      </div>
                      <div className="mb-4 flex items-center pl-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                        <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                          &#8377;
                        </div>
                        <p className=" text-h5 text-secondary-dark font-semibold">
                          Amount to pay:{" "}
                          <span className="text-heading  ml-[73px]">
                            {payment.final}
                          </span>
                        </p>
                      </div>
                      {inSufficientBalance && (
                        <p className="flex items-center text-secondary-light text-h5 text-left mb-2">
                          <span className="mr-2">
                            <svg
                              width="25"
                              height="22"
                              viewBox="0 0 25 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0265 0C5.39521 0 0 4.85983 0 10.8333C0 16.8068 5.42058 21.6667 12.0833 21.6667C18.7461 21.6667 24.1667 16.8068 24.1667 10.8333C24.1667 4.85983 18.7207 0 12.0265 0ZM13.2917 16.25H10.875V14.0833H13.2917V16.25ZM13.2917 11.9167H10.875V5.41667H13.2917V11.9167Z"
                                fill="#FF3737"
                              />
                            </svg>
                          </span>
                          Your account balance is insufficient to complete this
                          transaction.
                          <RouterLink
                            to={ROUTES.WALLET}
                            className="ml-2 font-semibold text-tertiary-dark underline"
                          >
                            Add Money
                          </RouterLink>
                        </p>
                      )}
                      {inSufficientBalance ? (
                        <div className="flex justify-end">
                          <BtnSmallDisabled
                            onClick={() =>
                              setModals((prevState) => ({
                                ...prevState,
                                addNew: false,
                              }))
                            }
                          >
                            Pay
                          </BtnSmallDisabled>
                        </div>
                      ) : (
                        <div className="flex justify-end mt-10">
                          <BtnSmall
                            onClick={() => {
                              setModals((prevState) => ({
                                ...prevState,
                                addNew: false,
                              }));
                              handlePayment();
                            }}
                          >
                            Pay
                          </BtnSmall>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <h2 className="text-heading font-semibold text-left mb-4">
                        OTP has been sent for User Authentication
                      </h2>
                      <p className="text-secondary-light text-h5 text-justify mb-8">
                        One Time Password had been sent to your Mobile no. and
                        Email Address. Please enter the verification code.
                        Tibdolor sit ametre, consectetur adipiscing elit. At
                        aliquet ut facilisi nulla mauris.
                      </p>
                      <div className="flex items-center mb-8">
                        <input
                          type="text"
                          onChange={handleOtp}
                          ref={firstInputRef}
                          name="first"
                          value={otp.first}
                          className="outline-0 border-0 font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          type="text"
                          onChange={handleOtp}
                          name="second"
                          ref={secondInputRef}
                          value={otp.second}
                          className="outline-0 border-0 font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          type="text"
                          onChange={handleOtp}
                          value={otp.third}
                          ref={thirdInputRef}
                          name="third"
                          className="outline-0 border-0 font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          type="text"
                          onChange={handleOtp}
                          ref={fourthInputRef}
                          name="fourth"
                          value={otp.fourth}
                          className="outline-0 border-0 font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          type="text"
                          onChange={handleOtp}
                          ref={fifthInputRef}
                          name="fifth"
                          value={otp.fifth}
                          className="outline-0 border-0 font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                        <input
                          type="text"
                          onChange={handleOtp}
                          ref={sixthInputRef}
                          name="sixth"
                          value={otp.sixth}
                          className="outline-0 border-0 font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                      </div>

                      <p className="mb-6 text-left text-heading-false font-semibold text-p1">
                        Didn't receive the OTP?{" "}
                        <span className="text-secondary-light underline">
                          <Timeout handleClick={handlePayment} start={60} />
                        </span>
                      </p>

                      {!confirmOTP ? (
                        <div className="text-right">
                          <BtnSmallDisabled
                            onClick={() =>
                              setModals((prevState) => ({
                                ...prevState,
                                addNew: false,
                              }))
                            }
                          >
                            Submit
                          </BtnSmallDisabled>
                        </div>
                      ) : (
                        <div className="text-right">
                          <BtnSmall
                            onClick={() => {
                              setModals((prevState) => ({
                                ...prevState,
                                addNew: false,
                              }));
                              setOtp((prev) => ({
                                ...prev,
                                first: "",
                                second: "",
                                third: "",
                                fourth: "",
                                fifth: "",
                                sixth: "",
                              }));
                              otpVerification();
                            }}
                          >
                            Submit
                          </BtnSmall>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <button
                  onClick={() =>
                    setModals((prevState) => ({ ...prevState, payment: false }))
                  }
                  className="absolute top-8 right-8"
                >
                  <svg
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                      fill="black"
                      fillOpacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            </DialogBox>
          )}
          {accessIdCreated && (
            <DialogBox>
              <PopUp
                onClick={() => {
                  setAccessIdCreated(false);
                  navigate(ROUTES.CATALOGUE);
                }}
                title="Access Ids created"
                body="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utvest-ibulum bibendum egestas. Enim mi arcu convallis enim purus interdum. Ut neque at adipiscing tortor facilisis sagittis libero. Ac bibendum vel blandit."
                main="You have successfully created 109 access ids"
                button="Confirm"
              />
            </DialogBox>
          )}
        </>
      )}
    </Page>
  );
}
